import OptionHOC, { getOptionLabel } from 'platform/react/hoc/autocomplete/option'
import OverflowTooltip from 'ui/Element/Text/OverflowTooltip'
import { Box } from '@mui/material'

const style = theme => ({
  delegates: {
    color: theme.palette.warning.main,
  },
})

/**
 * Displays the name of a team, colored in warning color if its `delegateAndCloseOnAssign` property
 * is `true`
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
const TeamWithDelegationWarningOption = (classes, props = {}) => {
  const { option } = props
  const {
    value: { delegateAndCloseOnAssign } = {},
  } = option || {}

  return (
    <Box
      key={'item'}
      component={'div'}
      className={classes.option}
    >
      <OverflowTooltip
        className={delegateAndCloseOnAssign ? classes.delegates : ''}
      >
        {getOptionLabel(option)}
      </OverflowTooltip>
    </Box>
  )
}

export default OptionHOC(TeamWithDelegationWarningOption, style)
